import React from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {EstiloDetail} from "./estilo-detail";

const EstiloDetailPage = React.memo(() => {

    const {id} = useParams();
    let navigate = useNavigate();

    const onClose = () => {
        navigate('/estilos');
    }

    return (
        <EstiloDetail id={id} onClose={onClose}/>
    )

});

export default EstiloDetailPage;